import { colorsCategorical } from '@/constants';

export const colorsProject = [
  ...colorsCategorical,
  '#8a0083',
  '#009e84',
  '#7eff5e',
  '#8400ff',
  '#0091a1',
];

export default {
  colorsProject,
};
